import {NgModule} from "@angular/core";
import {AssetSelectionComponent} from "./asset-selection.component";
import {FormsModule} from "@angular/forms";
import {BrowserModule} from "@angular/platform-browser";
import {PaginationModule} from "../pagination/pagination.module";

@NgModule({
  imports: [BrowserModule, FormsModule, PaginationModule],
  declarations: [AssetSelectionComponent],
  exports: [AssetSelectionComponent],
})
export class AssetSelectionModule {}
